export default {
	colors_() {
		return ['#13C7A3', '#89FB89', '#82F0F0', '#99CCFF', '#A0DFE1', '#6FCC98', '#AAEBAA'];
	},
	stackedLabel_: ({ graphList }) => {
		const labelArray = [];
		for (const item of graphList) {
			labelArray.push(item.ckuDd);
		}
		return labelArray;
	},
	//검사상태(조회조건) selectBox
	getPgsStPcCdList_({ pgsStPcCdList }) {
		const list = [];
		pgsStPcCdList.length && pgsStPcCdList.forEach(row => list.push({ label: row.label, value: row.value }));
		return list;
	},
	//유형(조회조건) selectBox
	getPartClCdList_({ partClCdList }) {
		const list = [];
		partClCdList.length && partClCdList.forEach(row => list.push({ label: row.label, value: row.value }));
		return list;
	},
	stackedDataSet_: ({ graphList }, getters, rootState, rootGetters) => {
		const barData = [],
			linePass = [],
			lineBad = [];
		for (const val of graphList) {
			barData.push(val.ckuQty);
			linePass.push(val.passQty);
			lineBad.push(val.badQty);
			// linePass.push(val.passPro);
			// lineBad.push(val.badPro);
		}
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001221'), //합격수량
				data: linePass,
				borderColor: '#9AB9FF',
				backgroundColor: '#E8F5FF',
				type: 'line',
				order: 0
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000074'), //불량수량
				data: lineBad,
				borderColor: '#FF7E9D',
				backgroundColor: '#FFF0F5',
				type: 'line',
				order: 1
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000073'), //검사수
				data: barData,
				borderColor: '#CE69E7',
				backgroundColor: '#CE69E7',
				borderWidth: 1,
				order: 2
			}
		];
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000958'), //협력사
				prop: 'cofNm',
				minWidth: '90px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000957'), //품명
				prop: 'partNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '120px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000005'), //검사번호
				prop: 'ckuNo',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000069'), //유형
				prop: 'partClNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000070'), //검사일
				prop: 'ckuDd',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001217'), //검사시작
				prop: 'ckuStrtDt',
				minWidth: '180px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001218'), //검사종료
				prop: 'ckuEndDt',
				minWidth: '180px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001219'), //검사상태
				prop: 'pgsStNm',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000073'), //검사수량
				prop: 'ckuQty',
				minWidth: '70px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001220'), //초과수량
				prop: 'excsQty',
				minWidth: '70px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001221'), //합격수량
				prop: 'passQty',
				minWidth: '70px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000074'), //불량수량
				prop: 'badQty',
				minWidth: '70px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001222'), //판정결과
				prop: 'ovrlJgmtNm',
				minWidth: '70px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001223'), //검사자
				prop: 'ckurNm',
				minWidth: '90px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('SWCC000747'), //검사종료
				prop: 'rmkHis',
				minWidth: '180px'
			}
		];
	}
};
